<template>
    <modal height="auto" width="90%" :scrollable="true" @opened="onOpen" @closed="onHidden" name="electronic-prescription" classes="modal_default" :clickToClose="true">
    <div class="card">
        <div class="card-header">
            Doplnění údajů k eReceptům
        </div>
        <div class="card-body">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>#</th>
                        <th scope="col">Předepsané léky</th>
                        <th scope="col">Akutní</th>
                        <th scope="col">Rodina</th>
                        <th scope="col">Poznámka</th>
                        <th scope="col">Platnost</th>
                        <th scope="col">Notifikace</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(ep, index) in electronicPrescriptions">
                        <td>{{ index }}</td>
                        <td>
                            <template v-for="(m, index) in ep.medicaments">
                                <span>{{ m.medicine ? m.medicine.label : '' }}
                          {{ m.individual_medicine ? m.individual_medicine.name : '' }}</span><br>
                            </template>
                        </td>
                        <td>
                            <label class="switch switch-lg switch-text switch-success">
                            <input v-model="ep.acute" type="checkbox" class="switch-input" id="acute" checked>
                            <span class="switch-label" data-on="Ano" data-off="Ne"></span>
                            <span class="switch-handle"></span>
                            </label>
                        </td>
                        <td>
                            <label class="switch switch-lg switch-text switch-success">
                                <input v-model="ep.family" type="checkbox" class="switch-input" id="family" checked>
                                <span class="switch-label" data-on="Ano" data-off="Ne"></span>
                                <span class="switch-handle"></span>
                            </label>
                        </td>
                        <td>
                            <input v-model="ep.note" type="text" class="form-control form-control-sm mr-sm-2" aria-describedby="note" id="note">
                        </td>
                        <td>
                            <select v-model="ep.validity" class="mr-sm-2" aria-describedby="valid" id="valid" >
                                <option :value="14">14 dnů</option>
                                <option :value="5">5 dnů</option>
                            </select>
                            <span v-if="ep.validity.toString() === '14'">běžný recept</span>
                            <span v-if="ep.validity.toString() === '5'">antibiotika či<br>chemoterapeutika</span>
                        </td>
                        <td>
                            <select v-model="ep.patientNotificationType" class="mr-sm-2" aria-describedby="notification" id="notification" >
                                <option v-for="(pn, index) in ep.possible_notification" :value="pn.key">{{ pn.label }}</option>
                            </select>
                        </td>
                        <td>
                            <button type="button" @click="updateEPrescription(ep)" class="btn btn-success btn-sm">Uložit</button>
                            <button type="button" @click="removeEPrescription(ep)" class="btn btn-danger btn-sm">Smazat</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-body">

        </div>
    </div>
    </modal>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        modalOpened: false,
        electronicPrescriptions: false,
        electronicPrescriptionsPending: true,
        electronicPrescriptionsError: false,
        deleteElectronicPrescriptionDone: false,
        deleteElectronicPrescriptionPending: false,
        deleteElectronicPrescriptionError: false,
        epPending: false,
        epDone: false,
        epError: false
      }
    },
    props: ['opened'],
    mixins: [apiMixin],
    methods: {
      onHidden () {
        // this.opened = false
      },
      onOpen () {
        this.init()
        this.getUnpreparedElectronicPrescriptions(this.visitId)
      },
      getUnpreparedElectronicPrescriptions () {
        this.electronicPrescriptionsPending = true
        this.$http.get('client/' + this.$route.params.clientid + '/prescription_electronic', {params: {status: 'UNPREPARED', filter_date: this.$moment().format('DD.MM.YYYY')}}).then(response => {
          this.electronicPrescriptions = response.data
          for (let index = 0; index < this.electronicPrescriptions.length; index++) {
            this.electronicPrescriptions[index].patientNotificationType = 'NO'
            this.electronicPrescriptions[index].validity = 14
            for (let medicamentIndex = 0; medicamentIndex < this.electronicPrescriptions[index].medicaments.length; medicamentIndex++) {
              if (this.electronicPrescriptions[index].medicaments[medicamentIndex].medicine.indication_group &&
                this.electronicPrescriptions[index].medicaments[medicamentIndex].medicine.indication_group.code === 15
              ) {
                this.electronicPrescriptions[index].validity = 5
              }
            }
          }
          this.electronicPrescriptionsPending = false
        }, response => {
          this.electronicPrescriptionsError = response.body.error
          this.electronicPrescriptionsPending = false
        })
      },
      init () {
        this.electronicPrescriptions = false
        this.electronicPrescriptionsPending = false
        this.electronicPrescriptionsError = false
      },
      updateEPrescription (ep) {
        let epForUpdate = {
          id: ep.id,
          acute: ep.acute,
          family: ep.family,
          note: ep.note,
          validity: ep.validity,
          patientNotificationType: ep.patientNotificationType
        }
        this.epPending = true
        this.$http.put('prescription_electronic/' + epForUpdate.id, epForUpdate, {emulateJSON: true}).then(response => {
          this.epPending = false
          this.epDone = true
        }).catch(error => {
          this.epError = error.response.data.errors
          this.epPending = false
        })
      },
      removeEPrescription (ep) {
        this.deleteElectronicPrescription(ep)
      }
    },
    watch: {
      opened (val) {
        if (val === true) {
          // console.log('otevreno')
        }
      },
      '$route' (to, from) {
        if (to.params.visitId !== from.params.visitId && typeof (to.params.visitId) !== 'undefined') {
          // this.init()
        }
      },
      epDone (val) {
        if (val === true) {
          this.getUnpreparedElectronicPrescriptions()
          this.$emit('prescription-updated')
          this.epDone = false
        }
      },
      deleteElectronicPrescriptionDone (val) {
        if (val === true) {
          this.getUnpreparedElectronicPrescriptions()
          this.deleteElectronicPrescriptionDone = false
        }
      },
      electronicPrescriptionsPending (val) {
        if (val === false && this.electronicPrescriptions.length < 1) {
          this.$modal.hide('electronic-prescription')
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    @media screen
    {
        .noPrint{}
        .noScreen{display:none;}
    }

    @media print
    {
        .noPrint{display:none;}
        .noScreen{}
    }


</style>



// WEBPACK FOOTER //
// src/views/Client/modals/ElectronicPrescription.vue?528188cc